module.exports = __webpack_public_path__ + "static/media/m3d_logo.7f17eba4.png";